import { h } from "vue";
import type { IconSet, IconProps } from "vuetify";
import { Icon } from '#components';

export default function iconify(set: string): IconSet {
  return {
    component: (props: IconProps) =>
    h(Icon, {
      name: `${set}:${props.icon}`,
      disabled: props.disabled,
    })
  };
}